<template>
  <v-dialog scrollable v-model="showModalInternal" max-width="800px" @close="onClose">
    <v-card v-if="email">
      <v-card-title class="d-flex justify-space-between align-start flex-nowrap">
        <div class="flex-grow-1 d-flex align-center"><v-icon left>mdi-email-search</v-icon>{{ trans('emailSettings.showEmail') }}</div>
        <v-btn icon small class="ml-2" @click="close"><v-icon small>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <div class="mt-2">
          <form-input readonly hide-details cols="10" cols-help="0" :label="trans('emailSettings.subject')" :value="email.subject"></form-input>
          <form-input readonly hide-details cols="10" cols-help="0" :label="trans('emailSettings.fromEmail')" :value="fromFull || '-'"></form-input>
          <form-input readonly hide-details cols="10" cols-help="0" :label="trans('emailSettings.to')" :value="email.to"></form-input>
          <form-input readonly hide-details cols="10" cols-help="0" :label="trans('emailSettings.cc')" v-if="email.cc" :value="email.cc"></form-input>
          <form-input readonly hide-details cols="10" cols-help="0" :label="trans('emailSettings.bcc')" v-if="email.bcc" :value="email.bcc"></form-input>
          <form-input readonly hide-details cols="10" cols-help="0" :label="trans('emailSettings.status')">
            <template v-slot:input>
              <email-status :email="email"></email-status>
            </template>
          </form-input>
          <form-input readonly hide-details cols="10" cols-help="0" :label="trans('emailSettings.sentAt')" v-if="email.successfullySentAt" :value="formatDate(email.successfullySentAt, 'LLL')"></form-input>
          <form-input readonly hide-details cols="10" cols-help="0" :label="trans('emailSettings.lastTriedAt')" v-else :value="formatDate(email.lastTriedAt, 'LLL')"></form-input>
          <form-input readonly hide-details cols="10" cols-help="0" :label="trans('emailSettings.attachments')">
            <template v-slot:input>
              <template v-if="email.attachments && email.attachments.length > 0">
                <v-chip
                  small
                  v-for="(emailAttachment, i) in email.attachments"
                  :key="i"
                >
                  <v-icon small class="mr-1">mdi-file-outline</v-icon>
                  {{ emailAttachment.filename }} <span class="font-weight-bold ml-2" style="font-size: 0.8em;">({{ getByteSizeReadable(emailAttachment.size) }})</span>
                </v-chip>
              </template>
              <div v-else>-</div>
            </template>
          </form-input>
        </div>
        <v-divider class="mt-3 mb-2"></v-divider>
        <iframe :srcdoc="email.content" style="width: 100%; border: none;" :style="{height: emailContentHeight + 'px'}"></iframe>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils';
import FormInput from './FormInput';
import {DateUtils} from '../utils/date-utils';
import EmailStatus from './EmailStatus';

export default {
  name: 'EmailModal',
  components: {EmailStatus, FormInput},
  mixins: [
    LocaleUtils,
    DateUtils
  ],
  props: {
    showModal: {},
    /** @type {EmailDto} email */
    email: {
      required: true
    }
  },
  data () {
    return {
      showModalInternal: false
    }
  },
  beforeDestroy () {
    this.close();
    this.$emit('update:show-modal', false);
  },
  watch: {
    showModal (showModal) {
      this.showModalInternal = showModal;
    },
    showModalInternal (showModalInternal) {
      this.$emit('update:show-modal', showModalInternal);
    }
  },
  methods: {
    onClose () {
      this.$emit('close');
    },
    close () {
      this.showModalInternal = false;
    },
    getByteSizeReadable (byteSize) {
      let size = byteSize;
      let unit = 'B';

      if (size > 1024) {
        size = Math.round(size / 1024);
        unit = 'KB';
        if (size > 1024) {
          size = Math.round(size / 1024);
          unit = 'MB';
        }
      }

      return size + ' ' + unit;
    }
  },
  computed: {
    emailContentHeight () {
      return Math.min(window.innerHeight - 500, 1000);
    },
    fromFull () {
      return `${this.email.fromName || ''} <${this.email.from || ''}>`
        .replace('<>', '')
        .trim();
    }
  }
}
</script>
